import React, { useState, useRef, useEffect, useContext } from "react";

import { Box, Card, Container, Grid, Typography, TextField, Stack, Button, CircularProgress, Paper, InputLabel, OutlinedInput, InputAdornment, FormControl, FormControlLabel, Switch } from '@mui/material';

import Autocomplete from '@mui/material/Autocomplete';

import CmsContext from '../../../../store/cms-context';

import { getAccessJwtToken } from '../../../../store/globalUtilities';

import { useNavigate } from 'react-router-dom';

import { Analytics, Storage } from 'aws-amplify';
import { alpha, styled } from '@mui/material/styles';
import { grey , blue} from '@mui/material/colors';
import TimePicker from '@mui/lab/TimePicker';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { clone, cloneDeep, min } from "lodash";
import { ONE_DAY } from "../../../../Utilities/Metrics";

import TimezoneSelect from "react-timezone-select";

import currencySymbols from "../../../../Utilities/CurrencieSymbols";
import { has_product_management_write_access } from "../../../../Utilities/HelperFunctions";


const CustomSwitch = styled(Switch)(({ theme }) => ({

  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      '& .MuiSwitch-thumb': {
        color:blue[800]
      }
    },
    '&:hover': {
      backgroundColor: alpha(blue[600], theme.palette.action.hoverOpacity),
    }
  },
  '& .MuiSwitch-thumb': {
    color:grey[200]
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: blue[300],
        opacity: 1,
        border: 0,
  },
  
}));


// 50 Denier Tights - Blueberry Muffin
// 30 Denier Sheer Tights - Lemon
// 30 Denier Sheer Tights - Pirouette
// 30 Denier Sheer Tights - Pomegranate
// Your HighNess
// Feline Myself
// Stay Cool Chub Rub Shorts - New Wave
// Stay Cool Chub Rub Shorts - Diamond Age
// Big Softee Towel - Black
// Lunar
// Check why lunar not on Test NL (Sync)

const skus = [
  'SNAG-50-BLUEBERRY',
  'SNAG-30-V3-LEMON',
  'SNAG-30-V3-PIROUETTE',
  'SNAG-30-V3-POMEGRANATE',
  'SNAG-MD-YOURHIGHNESS-BLACK',
  'SNAG-FISHIES-FELINEMYSELF-BLACK',
  'SNAG-CHUBRUBS-NEWWAVE-BLACK',
  'SNAG-CHUBRUBS-DIAMONDAGE-BLACK',
  'SNAG-TOWEL-BIGSOFTEE-BLACK',
  'SNAG-CAPRI-80-BLOK9-BLACK'
]


function ShopifyCollectionsInventorySort(props) {

  const cmsContext = useContext(CmsContext);

  const isMountedRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);

  const [all_stores, set_all_stores] = React.useState([]);

  const [active_stores, set_active_stores] = React.useState([]);

  const navigate = useNavigate();


  useEffect(() => {

    isMountedRef.current = true

    get_configurations_settings()

    return () => isMountedRef.current = false;

  }, [])




  function handle_active_stores_change(event, newValue){

    set_active_stores(newValue)

  }


  return(

    <>

   {isLoading ? <CircularProgress style={{position: 'absolute', top: '50%', left: '50%', MozTransform: 'translateX(-50%) translateY(-50%)', WebkitTransform: 'translateX(-50%) translateY(-50%)', transform: 'translateX(-50%) translateY(-50%)'}} /> :
   
   <Box
    component="main"
    sx={{
      flexGrow: 1,
      py: 8,
    }}
  >


    <Container maxWidth={false} style={{maxWidth:"1000px",overflow:'visible'}}>
  
    <Grid
        container
        spacing={2}
        style={{overflow:'visible'}}
      >

        <Grid
          item
          xs={12}
        >

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-end"
          spacing={2}
        >

          <Typography variant="h5">Configurations</Typography> 

          <div>

          <Button variant="contained" onClick = {() => {update_configurations("rules")}}>Update Configurations</Button>

          </div>

        </Stack>

      </Grid>

      <Grid
          item
          xs={12}
        >

      <Paper elevation = {2} style={{marginTop:16, padding:20}}>
        
        <Grid
          container
          spacing={3}
          alignItems="center"
        >

          <Grid
            item
            xs={12}
          >

          <Autocomplete
                multiple
                id="active-stores"
                options={all_stores}
                getOptionLabel={(option) => option.name}
                value={active_stores}
                isOptionEqualToValue={(option, value) => option.store === value.store}
                onChange={(event, newValue) => {handle_active_stores_change(event, newValue)}}
                renderInput={(params) => (
                  <TextField {...params} label="Active stores" placeholder="Active stores" />
                )}
          />     

        </Grid>

    

        {active_stores.map((store, index) => { 

          return(

            <Grid key={index} item xs={12} >

            <Grid container spacing={2}>

            <Grid
            item 
            xs={12}
            >

              <Typography style={{marginBottom:8}} fontSize={12}><strong>{store.name}</strong></Typography>

            </Grid>

            <Grid
              item
              xs={12}
              md={12}
              > 

              <Autocomplete
                    id="collection"
                    multiple
                    options={store.all_collections}
                    getOptionLabel={(option) => option.title ? option.title : ''}
                    value={store.selected_collections ? store.selected_collections : []}
                    isOptionEqualToValue={(option, value) => option.id === value.id }
                    onChange={(event, newValue) => {

                      const temp_stores = [...active_stores]

                      temp_stores[index].selected_collections = newValue

                      set_active_stores(temp_stores)

                    }}
                    renderOption={(props, option) => {
                      return (
                        <li {...props} key={option.id}>
                          {option.title}
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField size="small" {...params} label="Order collections" placeholder="Order collections" />
                    )}
              />     

            </Grid>

            
            <Grid
              item
              xs={6}
            >

                <LocalizationProvider LocalizationProvider dateAdapter={AdapterDateFns}>
                <TimePicker
                  label="Schedule"
                  value={active_stores[index].schedule != null ? active_stores[index].schedule : null}
                  onChange={(newValue) => {

                    console.log('value was: ', newValue)

                    const temp_stores = [...active_stores];

                    temp_stores[index].schedule = newValue;

                    set_active_stores(temp_stores);

                  }}
                  renderInput={(params) => <TextField size="small" {...params} fullWidth/>}
                />
              </LocalizationProvider>

            </Grid>



            <Grid item xs={6}>

              <div style={{position:'relative', zIndex:1000 - index, marginTop:1}}>
          
              <TimezoneSelect
                value={store.time_zone != null ? store.time_zone : ''}
                onChange={(value) => {console.log('value was: ', value); const temp_stores = [...active_stores]; temp_stores[index].time_zone = value; set_active_stores(temp_stores);}}
              />

              </div>
     
            </Grid>


          </Grid>

          </Grid>

          )
            
          })}

        </Grid>

        </Paper>


    
        </Grid>



      </Grid>

    </Container>      


    </Box>

     }

    </> 


  );

  function get_configurations_settings() {
    
    console.log('store_access_token')

    // user api

    // error handling and state managment required

    setIsLoading(true)

    getAccessJwtToken().then((auth_creds)=>{

      fetch('https://fri7xzt2n6.execute-api.eu-west-2.amazonaws.com/SnagCMS/shopify/collections/inventory/sort/configs ',{
          crossDomain:true,
          method: 'GET',
          headers: {
            'Authorization':auth_creds.jwt
          }})
          .then(res => res.json())
          .then(
            (result) => {
  
              setIsLoading(false)
  
              console.log('result was: ', cloneDeep(result))

              if(result.data){

              var stores = result.data.stores

              set_all_stores(stores)

                const act_stores = result.data.active_stores;

                const temp_act_stores = []

                if(act_stores && act_stores.length > 0){

                for (var z=0; z< stores.length; z++){

                  for (var z1=0; z1 < act_stores.length; z1++){

                    if(act_stores[z1].store === stores[z].store){

                      console.log("Yes matched")

                      const temp_store = act_stores[z1]

                      temp_store.name = stores[z].name

                      temp_store.currency = stores[z].currency

                      temp_store.all_collections = stores[z].all_collections

                      if(temp_store.time_zone == null){
                        temp_store.time_zone = ''
                      }

                      if(temp_store.schedule != null) {
  
                        const start_date = new Date();
  
                        start_date.setHours(parseInt(temp_store.schedule.split(":")[0]))
  
                        start_date.setMinutes(parseInt(temp_store.schedule.split(":")[1]))
  
                        start_date.setSeconds(0)
  
                        temp_store.schedule = start_date
  
                        console.log('schedule was: ', start_date)
  
                      }
  
                      temp_act_stores.push(temp_store)

                      break;

                    }

                  }

                }

                console.log("setting active stores: ", temp_act_stores)


                set_active_stores(temp_act_stores)

              }


        
            }else if(result.errorMessage){

              cmsContext.setSnackBarOpen(true, "error", result.errorMessage)
              
            } else{
              cmsContext.setSnackBarOpen(true, "error", "Error fetching data, please reload page")
              console.log('Error', result)
            }
  
            },
        
            (error) => {
              setIsLoading(false)
              cmsContext.setSnackBarOpen(true, "error", "Error fetching data, please reload page")
              console.log('error was',error)
            }
      )

    })


  }

  function update_configurations(){

    console.log('updating')

    var request_body = {}

    request_body.configurations = {}

    var act_stores = cloneDeep(active_stores)

    console.log("active stores were: ", act_stores)

    if(act_stores.length === 0){

      cmsContext.setSnackBarOpen(true, "error", "Please select atleast one store!")
      return

    }

    var found_collection_error = false;

    var found_cart_error = false;

    for (var i=0; i < act_stores.length; i++){

      if(act_stores[i].discount && act_stores[i].discount.toString().trim().length > 0 && act_stores[i].discount < 1){

        found_cart_error = true;
        //break

      }else{

        found_cart_error = false;

      }


      if(!(act_stores[i].selected_collections && act_stores[i].selected_collections.length > 0)){

        found_collection_error = true;

      }else{

        found_collection_error = false;

      }


      if(found_collection_error || found_cart_error){

        break

      }

      var schedule = act_stores[i].schedule

      if(schedule) {

        if(isNaN(schedule.getHours()) || isNaN(schedule.getMinutes())) {

          found_collection_error = true;
          break

        } else {

          schedule = schedule.getHours().toString() + ":" + schedule.getMinutes().toString()
          act_stores[i].schedule = schedule;

        }

      }
      else{

        found_collection_error = true;

      }

      if(act_stores[i].time_zone ==  null) {
        
        found_collection_error = true;

      }

      act_stores[i] = {store: act_stores[i].store, time_zone: act_stores[i].time_zone, schedule: schedule, selected_collections: act_stores[i].selected_collections}

    }

    if(found_collection_error || found_cart_error){
      cmsContext.setSnackBarOpen(true, "error", "Please enter valid values for all fields!")
      return
    }


    request_body.configurations = act_stores;

    request_body.request_type = "Update";

    console.log('request body: ', request_body)

    setIsLoading(true)

    getAccessJwtToken().then((auth_creds) => {

      if(!has_product_management_write_access(auth_creds.current_user)){
        cmsContext.setSnackBarOpen(true, "error", "You do not have permission to perform this action!")
        setIsLoading(false)
        return
      }
      

      fetch('https://fri7xzt2n6.execute-api.eu-west-2.amazonaws.com/SnagCMS/shopify/collections/inventory/sort/configs', {
          crossDomain:true,
          method: 'POST',
          headers: {
            'content-type':'application/json',
            'Authorization':auth_creds.jwt
          },
          body: JSON.stringify(request_body)
        })
          .then(res => res.json())
          .then(
            (result) => {
  
              setIsLoading(false)
  
              console.log('result was: ', result)

              if(result.message){

                cmsContext.setSnackBarOpen(true, "success", result.message)

                get_configurations_settings()
              
              }else if(result.errorMessage){

                cmsContext.setSnackBarOpen(true, "error", result.errorMessage)
                
              }else{

                cmsContext.setSnackBarOpen(true, "error", "Error fetching data, please reload page")
                console.log('Error', result)

              }
  
            },
        
            (error) => {
              setIsLoading(false)
              cmsContext.setSnackBarOpen(true, "error", "Error completing request, please try again")
              console.log('error was',error)
            }
      )

    })


  }


};


export default ShopifyCollectionsInventorySort;